module.exports = __webpack_public_path__ + "static/media/bone_annot.3577410e.png";